import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1l0p6jh",
  propsAsIs: false
});
export const CheckInOutWrapper = /*#__PURE__*/styled('div')({
  name: "CheckInOutWrapper",
  class: "c1xnakhu",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => ({
  alignedRight = false
}) => alignedRight ? 'flex-end' : 'flex-start';
export const DetailsWrapper = /*#__PURE__*/styled('div')({
  name: "DetailsWrapper",
  class: "d1adyuy2",
  propsAsIs: false,
  vars: {
    "d1adyuy2-0": [_exp9()]
  }
});
const _exp10 = /*#__PURE__*/() => Text;
export const CheckInTextContainer = /*#__PURE__*/styled(_exp10())({
  name: "CheckInTextContainer",
  class: "c19ltxy6",
  propsAsIs: true
});
export const DottedLineContainer = /*#__PURE__*/styled('div')({
  name: "DottedLineContainer",
  class: "dbgogg4",
  propsAsIs: false
});
export const DottedLine = /*#__PURE__*/styled('div')({
  name: "DottedLine",
  class: "dvbbvvk",
  propsAsIs: false
});
export const Circle = /*#__PURE__*/styled('div')({
  name: "Circle",
  class: "c1qvub3s",
  propsAsIs: false
});
export const LowerCase = /*#__PURE__*/styled('span')({
  name: "LowerCase",
  class: "lwthh9o",
  propsAsIs: false
});
export const PrimaryLoadingWrapper = /*#__PURE__*/styled('div')({
  name: "PrimaryLoadingWrapper",
  class: "p1haqmd1",
  propsAsIs: false
});
const _exp23 = /*#__PURE__*/() => Flex.Row;
export const SecondaryRow = /*#__PURE__*/styled(_exp23())({
  name: "SecondaryRow",
  class: "stysarj",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");